import { client } from "./api/client";
import { buildAllClubsURL } from "./api/urlBuilder";
import { CreateClubPayload } from "../util/types";

export async function getAllClubs(token: string) {
    try {
        const response = await client.get(buildAllClubsURL(), { token });
        return response.data;
    } catch (error) {
        // Handle errors as needed
        console.error('Error fetching clubs:', error);
        throw error;
    }
}

export async function createClub(clubData: CreateClubPayload, token: string) {
    try {
        const response = await client.post(buildAllClubsURL(), clubData, { token });
        return response.data;
    } catch (error) {
        console.error('Error creating club:', error);
        throw error;
    }
}
